/**
 * This module contains global configuration values that are not different per environment.
 * It is not meant to be used for environment-specific values like Authentication, APIs, client secrets, etc. as
 * values here will be included in all production bundles unchanged.
 *
 * Environment-specific values are configured in src/static/config/config.json for local sandbox development,
 * and in the client-management-portal-config project for other environments. See README.md for more details.
 */

const identityUserUrl = 'identity/v1/Users';
const orgServiceUrl = 'organization/api';
const identityVerificationUrl = 'verification';
const billingUrl = 'rest/v1';
const tfaUrl = 'tfa/users';
const devicesUrl = 'devmgmt/v1';
const mtgServiceUrl = 'rest/2';
const oauthPortalUrl = 'oauthportal';

export default {
  routes: {
    clients: () => '/clients',
    'clients.clientedit': (clientId) => `/clients/clientedit/${clientId}`,
    'clients.clientedit.add': () => `/clients/clientedit`,
    'clients.clientcreate': () => `/clients/clientcreate`,
    noKey: {
      unauthorized: () => '/unauthorized',
      error: () => '/error',
    },
  },
  endpoints: {
    me: `${identityUserUrl}/me`,
    meWithUniqueParam: `${identityUserUrl}/me?u=${new Date().valueOf()}`,
    avatarUrls: `${identityUserUrl}/me/avatarurls`,
    organizationMe: `${orgServiceUrl}/me`,
    organizationByKey: (organizationKey) => `${orgServiceUrl}/organizations/${organizationKey}`,
    organizationDomains: (organizationKey) => `${orgServiceUrl}/organizations/${organizationKey}/domains`,
    organizationAdmins: (organizationKey) => `${orgServiceUrl}/organizations/${organizationKey}/admins`,
    identityVerificationEmail: `${identityVerificationUrl}/emails`,
    identityUserById: (userId) => `${identityUserUrl}/${userId}`,
    billingAccountMe: `${billingUrl}/me`,
    tfaMe: `${tfaUrl}/me`,
    forceSamlSso: 'samlRequired',
    devices: `${devicesUrl}/devices`,
    portalClient: 'client',
    portalClients: 'clients',
    portalClientById: (clientId) => `client/${clientId}`,
    portalClientsById: (clientId) => `clients/${clientId}`,
    mtgServiceSettings: `${mtgServiceUrl}/settings`,
    portalAdminClientGetEndpoint: `/me`,
    clientSecretKeysById: (clientId) => `clients/${clientId}/secrets`,
    clientSecretKeyBySecretId: (clientId, secretId) => `clients/${clientId}/secrets/${secretId}`,
    oAuthPermissions: (clientId) => `${oauthPortalUrl}/clients/${clientId}/permissions`,
    oAuthRoles: `/roles`,
    oAuthScopesManagement: `/scopes`,
    socialService: (text) => `users/me/indexes/_account?typeahead=${text}&limit=5`,
    oAuthScopes: 'oauthportal/scopes?limit=100&public=true',
    oauthScopeIsValid: (scopeName) => `/scopes/${scopeName}`,
    oAuthClientOwner: (clientId) => `/clients/${clientId}/owners`,
    oAuthClientOwnerDelete: (clientId, ownerEmail) => `/clients/${clientId}/owners/${ownerEmail}`,
    oAuthClientOwnerAdd: (clientId, ownerEmail) => `/clients/${clientId}/owners/${ownerEmail}`,
  },
  storage: {
    oauth: 'auth_token',
  },
  unauthorized: {
    redirect_time: 10,
  },
  scimSchemas: {
    core: 'urn:scim:schemas:core:1.0',
    enterprise: 'urn:scim:schemas:extension:enterprise:1.0',
    getGo: 'urn:scim:schemas:extension:getgo:1.0',
  },
  blackListedDomains: [
    'yahoo',
    'gmail',
    'outlook',
    'hotmail',
  ],
  toastrOptions: {
    timeOut: 6000,
  },
  alertTypes: {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger'
  },
  supportedLocales: [
    'de_DE',
    'en_US',
    'es_ES',
    'fr_FR',
    'it_IT',
    'zh_CN',
    'ja_JP',
    'ko_KR',
    'pt_BR',
  ],
  logMeInProducts: {
    g2ars: 'GoToAssist Remote Support',
    g2asd: 'GoToAssist Service Desk',
    g2aseeit: 'GoToAssist Seeit',
    g2m: 'GoToMeeting',
    g2t: 'GoToTraining',
    g2w: 'GoToWebinar',
    g2p: 'GoToMyPc',
    openvoice: 'OpenVoice',
    jive: 'GoToConnect',
    hvoice: 'HVoice',
    gotoconnect: 'GoToConnect',
    bold360: 'Bold360',
    gotoresolve: 'GoToResolve',
    grasshopper: 'Grasshopper',
  },
  // Two-Factor-Verification - list of products that support tfa.
  tfaSupportList: ['g2ars', 'g2asd', 'g2aseeit'],
  // Support experience "enumerations"
  supportExperiences: {
    DEFAULT: 'DEFAULT',
    HIDE: 'HIDE',
    JIVE_ONLY: 'JIVE_ONLY',
  },
  infoURLs: {
    supportUrl: '/support',
    faqUrl: '/guides/FAQ/Ref-API-Cost/'
  },
  devices: {
    highRiskThreshold: 0.9,
  },
  defaultProfileScope: 'identity:read',
  newPermissionList :{
    profile: "profile",
    collaboration: "collab",
    support: "support",
    scim: "org",
    admincenter: "admin",
    jive: "g2c"
  },

};
